module.exports = __webpack_public_path__ + "static/media/sa10_subwoofer.9bdf2efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/audio/sa10_subwoofer.png
// module id = 332
// module chunks = 0